export const APP_NAME = 'DrDerma';
export const PERSIST_STORE_NAME = 'admin';
export const REDIRECT_URL_KEY = 'redirectUrl';
